export default __webpack_public_path__ + "static/media/paypal-logo.a8e31141.jpg";